import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServicePL() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Powrót do aplikacji
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Warunki usługi</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Informacje o firmie</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Simple Stickers jest obsługiwane przez <span className="font-semibold">Puretech s.r.o.</span>,
                  <span className="font-semibold">spółkę z ograniczoną odpowiedzialnością</span> założoną zgodnie z prawem <span className="font-semibold">Republiki Czeskiej</span>.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-700 mb-2">Dane firmy:</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>IČO:</strong> 05503795</li>
                    <li><strong>Status VAT:</strong> Niepłatnik</li>
                    <li><strong>Adres siedziby:</strong> Heydukova 1035, 54401 Dvůr Králové nad Labem, Republika Czeska</li>
                    <li><strong>E-mail:</strong> support@simplestickers.app</li>
                    <li><strong>Strona:</strong> <a href="https://www.simplestickers.app" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 hover:underline">www.simplestickers.app</a></li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Akceptacja warunków</h2>
              <p className="leading-relaxed">
                Uzyskując dostęp i korzystając z Simple Stickers ("Usługa"), akceptujesz i zgadzasz się przestrzegać warunków niniejszej umowy. Jeśli nie zgadzasz się z powyższym, nie korzystaj z tej usługi.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Opis usługi</h2>
              <p className="leading-relaxed">
                Simple Stickers to aplikacja do zarządzania zadaniami i projektami, która zapewnia użytkownikom narzędzia do organizowania notatek za pomocą tablicy Kanban. Usługa obejmuje poziomy darmowy i premium z różnymi funkcjami i limitami użytkowania.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Konta użytkowników</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Jesteś odpowiedzialny za zachowanie poufności swojego konta i hasła oraz za ograniczenie dostępu do swojego komputera. Zgadzasz się przyjąć odpowiedzialność za wszystkie działania, które występują na Twoim koncie lub przy użyciu hasła.
                </p>
                <p className="leading-relaxed">
                  Tworząc konto, musisz podać dokładne i kompletne informacje oraz utrzymywać te informacje w aktualności.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Subskrypcja i warunki płatności</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Poziom darmowy:</strong> Obejmuje dostęp do podstawowych funkcji z ograniczoną liczbą notatek (50) i sugestii AI (10 dziennie).
                </p>
                <p className="leading-relaxed">
                  <strong>Poziom premium:</strong> Dostępny za 48 USD rocznie, obejmuje zwiększone limity (1000 notatek, 100 sugestii AI dziennie) i dodatkowe funkcje, takie jak udostępnianie notatek.
                </p>
                <p className="leading-relaxed">
                  Przetwarzanie płatności jest obsługiwane przez Polar. Subskrypcje odnawiają się automatycznie, chyba że zostaną anulowane. Możesz anulować subskrypcję w dowolnym momencie w ustawieniach konta.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Dopuszczalne użycie</h2>
              <p className="leading-relaxed">
                Zgadzasz się nie używać usługi do przechowywania, przesyłania lub dystrybucji treści, które są niezgodne z prawem, szkodliwe, groźne, obraźliwe, nękające, zniesławiające, wulgarne, obsceniczne lub w inny sposób niewłaściwe. Zgadzasz się również nie ingerować w usługę ani nie próbować uzyskać dostępu do kont innych użytkowników.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Prywatność i dane osobowe</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Twoja prywatność jest dla nas ważna. Szczegóły dotyczące tego, jak gromadzimy, wykorzystujemy i chronimy Twoje dane osobowe, znajdziesz w naszej <a href="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium">Polityce prywatności</a>.
                </p>
                <p className="leading-relaxed">
                  Korzystając z tej usługi, zgadzasz się również z naszą Polityką prywatności i przetwarzaniem Twoich danych osobowych zgodnie z RODO i odpowiednimi przepisami o ochronie danych.
                </p>
                <p className="leading-relaxed">
                  Aby skorzystać ze swoich praw wynikających z RODO lub w sprawach dotyczących ochrony danych, skontaktuj się z nami pod adresem <strong>support@simplestickers.app</strong>.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Dostępność usługi i wsparcie</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Dostępność usługi:</strong> Dążymy do maksymalnej dostępności usługi i niezawodnej pracy. W przypadku nieplanowanych awarii pracujemy nad ich szybkim rozwiązaniem. Usługę świadczymy "tak jak jest", bez formalnych gwarancji dostępności.
                </p>
                <p className="leading-relaxed">
                  <strong>Konserwacja:</strong> Aby zapewnić bezpieczeństwo i stabilność, możemy regularnie przeprowadzać konserwację usługi. Staramy się przeprowadzać planowaną konserwację w okresach niskiego ruchu i informujemy o tym z wyprzedzeniem, kiedy to możliwe. W pilnych przypadkach (np. łatki bezpieczeństwa) konserwacja może odbyć się bez wcześniejszego powiadomienia.
                </p>
                <p className="leading-relaxed">
                  <strong>Wsparcie:</strong> Oferujemy wsparcie techniczne za pośrednictwem e-maila support@simplestickers.app. Staramy się odpowiadać jak najszybciej, jednak nie gwarantujemy konkretnych czasów reakcji.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Polityka zwrotów</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>30-dniowa gwarancja zwrotu pieniędzy:</strong> Jeśli nie jesteś zadowolony z subskrypcji premium, możesz poprosić o pełny zwrot pieniędzy w ciągu 30 dni od pierwszego zakupu. Po 30 dniach wszystkie płatności są ostateczne i bezzwrotne.
                </p>
                <p className="leading-relaxed">
                  <strong>Błędy rozliczeniowe:</strong> Jeśli uważasz, że została Ci nieprawidłowo naliczona płatność, skontaktuj się z nami pod adresem support@simplestickers.app w ciągu 30 dni od rozliczenia.
                </p>
                <p className="leading-relaxed">
                  <strong>Przetwarzanie zwrotów:</strong> Zatwierdzone zwroty będą przetwarzane w ciągu 10-14 dni roboczych na oryginalną metodę płatności. Zastrzegamy sobie prawo do zatwierdzenia lub odrzucenia wniosków o zwrot według własnego uznania.
                </p>
                <p className="text-sm text-gray-600">
                  Uwaga: Anulowanie subskrypcji nie prowadzi automatycznie do zwrotu pieniędzy. Musisz wyraźnie poprosić o zwrot pieniędzy w ciągu 30-dniowego okresu.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Ograniczenia wiekowe i kwalifikowalność</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Minimalny wiek:</strong> Aby korzystać z tej usługi, musisz mieć co najmniej 16 lat.
                </p>
                <p className="leading-relaxed">
                  <strong>Zgoda rodziców:</strong> Użytkownicy poniżej 18 roku życia muszą mieć zgodę rodzica lub opiekuna na korzystanie z usługi.
                </p>
                <p className="leading-relaxed">
                  <strong>Użytkownicy korporacyjni:</strong> Konta korporacyjne wymagają, aby użytkownik miał uprawnienia do zaciągania zobowiązań w imieniu organizacji.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Prawo właściwe i jurysdykcja</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Niniejsze Warunki podlegają i są interpretowane zgodnie z prawem Republiki Czeskiej, bez względu na normy kolizyjne.
                </p>
                <p className="leading-relaxed">
                  Wszelkie spory wynikające z niniejszych Warunków lub Twojego korzystania z Usługi będą podlegać wyłącznej jurysdykcji sądów Republiki Czeskiej.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Moderacja treści</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Zastrzegamy sobie prawo do usunięcia, edycji lub odmowy wyświetlenia jakichkolwiek treści, które naruszają niniejsze Warunki lub które uważamy za niewłaściwe, według własnego uznania.
                </p>
                <p className="leading-relaxed">
                  Jeśli uważasz, że treść powinna zostać sprawdzona, skontaktuj się z nami pod adresem support@simplestickers.app.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Własność intelektualna</h2>
              <p className="leading-relaxed">
                Usługa oraz jej oryginalne treści, funkcje i funkcjonalność są własnością Simple Stickers i są chronione międzynarodowymi prawami autorskimi, znakami towarowymi, patentami, tajemnicami handlowymi i innymi prawami własności intelektualnej.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Ograniczenie odpowiedzialności</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  W maksymalnym zakresie dozwolonym przez obowiązujące prawo, Simple Stickers nie ponosi odpowiedzialności za jakiekolwiek szkody pośrednie, przypadkowe, specjalne, wynikowe lub przykładowe, w tym między innymi za utratę zysków, danych, użytkowania, wartości firmy lub innych strat niematerialnych wynikających z Twojego korzystania z usługi.
                </p>
                <p className="leading-relaxed">
                  To ograniczenie odpowiedzialności nie ma zastosowania do szkód spowodowanych umyślnym działaniem lub rażącym zaniedbaniem, lub jak jest to w inny sposób zabronione przez obowiązujące przepisy prawne.
                </p>
                <p className="leading-relaxed">
                  Nasza całkowita odpowiedzialność wobec Ciebie za wszelkie roszczenia wynikające z Twojego korzystania z usługi nie przekroczy kwoty, którą nam zapłaciłeś w ciągu 12 miesięcy poprzedzających roszczenie, lub 2 500 CZK, w zależności od tego, która kwota jest wyższa.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Zakończenie</h2>
              <p className="leading-relaxed">
                Możemy zakończyć lub zawiesić Twoje konto i zablokować dostęp do usługi natychmiast, bez wcześniejszego powiadomienia lub odpowiedzialności, według własnego uznania, z dowolnego powodu, w tym między innymi za naruszenie Warunków.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Zmiany warunków</h2>
              <p className="leading-relaxed">
                Zastrzegamy sobie prawo do modyfikowania lub zastępowania niniejszych Warunków w dowolnym czasie. Jeśli rewizja jest istotna, zapewnimy co najmniej 30 dni powiadomienia przed wejściem w życie nowych warunków.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Informacje kontaktowe</h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  Jeśli masz jakiekolwiek pytania dotyczące niniejszych Warunków usługi, skontaktuj się z nami:
                </p>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-700">
                    <strong>E-mail:</strong> support@simplestickers.app
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    W sprawach wsparcia, kwestii prawnych, prywatności, ochrony danych i zapytań biznesowych
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
